import {IModalService, IModalSettings} from "angular-ui-bootstrap";
import {OpenTraderHelpDialogController} from "./dialog/OpenTraderHelpDialog";

export class OpenTraderHelpDialogService {

    public static id = "openTraderHelpDialogService";

    /** @ngInject */
    public constructor(private $uibModal: IModalService) {

    }

    public async open(): Promise<void> {
        const options: IModalSettings = {
            templateUrl: "app/skin/om/help/service/dialog/OpenTraderHelpDialog.html",
            controller: OpenTraderHelpDialogController,
            controllerAs: "ctrl",
            windowClass: "tf-open-trader-help-dialog"
        };
        const instance = this.$uibModal.open(options);
        return instance.result;
    }
}
